<template>
<v-card class="ma-0">
    <div v-if="activeConditions.length > 0">
        <v-row class="ma-0" style="background: #3498db">
            <v-col cols="10">
                <v-row align="center" style="color: white;">
                    <v-col class="py-1 item-title" sm="3">{{ title }} 우선순위</v-col>
                    <v-col class="py-1">{{ buyConditionText }}</v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-divider />
        <draggable class="px-3" v-model="buyConditions" @change="updateBuyConditionsIndex" :disabled="disableDraggable">
            <condition-item v-for="item in buyConditions" :key="item.id" :item="item" @sort-change="changeSort" @remove="removeBuyCondition" @up="upIndex" @down="downIndex" />
        </draggable>
    </div>

    <div class="pa-5 text-center" v-else>
        최소 1개의 조건이 필요합니다
    </div>

    <v-divider class="py-2" />

    <div class="pb-2 text-center">
        <v-btn rounded small color="primary" @click="$refs.conditionDialog.show()">
            <v-icon>add</v-icon>
        </v-btn>
    </div>

    <condition-dialog ref="conditionDialog" @update="updateBuyConditionsIndex" />
</v-card>
</template>

<script>
import {
    db,
    auth
} from '@/firebase'
import draggable from 'vuedraggable'
import {
    DateFormat
} from '@/mixins/date.js'
import ConditionItem from '@/views/components/ConditionItem'
import ConditionDialog from '@/views/dialogs/ConditionDialog'

export default {
    name: 'condition-board',
    components: {
        draggable,
        ConditionItem,
        ConditionDialog
    },
    mixins: [
        DateFormat
    ],
    props: [
        'title'
    ],
    data() {
        return {
            buyConditions: [{
                    id: 'per',
                    index: 1,
                    name: 'PER',
                    order: 'ASC',
                    value: [1, 10],
                    min: -200,
                    max: 300,
                    active: true,
                    message: ""
                },
                {
                    id: 'pbr',
                    index: 2,
                    name: 'PBR',
                    order: 'ASC',
                    value: [0.3, 3],
                    min: 0.1,
                    max: 300,
                    active: false,
                    message: ''
                },
                {
                    id: 'psr',
                    index: 3,
                    name: 'PSR',
                    order: 'ASC',
                    value: [0.2, 3],
                    min: 0.1,
                    max: 300,
                    active: false,
                    message: ''
                },
                {
                    id: 'pcr',
                    index: 4,
                    name: 'PCR',
                    order: 'ASC',
                    value: [1, 10],
                    min: -200,
                    max: 300,
                    active: false,
                    message: ''
                },
                {
                    id: 'ncav',
                    index: 5,
                    name: 'NCAV',
                    order: 'DESC',
                    value: [-100, 100],
                    min: -1000,
                    max: 1000,
                    formatter: '{value}%',
                    active: false,
                    message: ''
                },
                {
                    id: 'roe',
                    index: 6,
                    name: 'ROE',
                    order: 'DESC',
                    value: [0, 30],
                    min: -200,
                    max: 200,
                    formatter: '{value}%',
                    active: false,
                    message: ''
                },
                {
                    id: 'roa',
                    index: 7,
                    name: 'ROA',
                    order: 'DESC',
                    value: [0, 30],
                    min: -200,
                    max: 200,
                    formatter: '{value}%',
                    active: false,
                    message: ''
                },
                {
                    id: 'gpa',
                    index: 8,
                    name: 'GP/A',
                    order: 'DESC',
                    value: [0, 30],
                    min: -200,
                    max: 200,
                    formatter: '{value}%',
                    active: false,
                    message: ''
                },
                {
                    id: 'op',
                    index: 9,
                    name: '영업이익률',
                    order: 'DESC',
                    value: [0, 30],
                    min: -200,
                    max: 200,
                    formatter: '{value}%',
                    active: false,
                    message: ''
                },
                {
                    id: 'profit',
                    index: 10,
                    name: '순이익률',
                    order: 'DESC',
                    value: [0, 30],
                    min: -200,
                    max: 200,
                    formatter: '{value}%',
                    active: false,
                    message: ''
                },
                {
                    id: 'debt',
                    index: 11,
                    name: '부채비율',
                    order: 'ASC',
                    value: [-100, 100],
                    min: -1000,
                    max: 1000,
                    formatter: '{value}%',
                    active: false,
                    message: ''
                },
                {
                    id: 'total_capital',
                    index: 12,
                    name: '시가총액',
                    order: 'DESC',
                    value: [1000, 10000000],
                    min: 0,
                    max: 10000000,
                    formatter: (v) => {
                        if (v >= 10000) return `${v/10000}조`
                        return `${v}억`
                    },
                    active: false,
                    message: ''
                }
            ],
        }
    },
    computed: {
        user() {
            return this.$store.getters.user
        },
        activeConditions() {
            return this.buyConditions.filter(v => v.active)
        },
        sortedConditions() {
            return this.activeConditions.sort(v => v.index)
        },
        buyConditionText() {
            return this.sortedConditions.map(v => v.name).join(" - ")
        },
        disableDraggable() {
            return this.$store.state.mobile
        }
    },
    created() {},
    async mounted() {},
    methods: {
        changeSort(item) {
            item.order = item.order == "ASC" ? "DESC" : "ASC"
        },
        load(loadedObject) {
            for (const condition of this.buyConditions) condition.active = false
            for (const item of this.$refs.conditionDialog.items) item.value = false

            const sort = loadedObject.sort.split(",")
            const order = loadedObject.order.split(",")
            let index = 0
            for (let i = 0; i < sort.length; i++) {
                const sortKey = sort[i]
                for (const condition of this.buyConditions) {
                    if (condition.id == sortKey) {
                        condition.active = true
                        condition.index = index++
                        condition.order = order[i]

                        let minValue = loadedObject[`${sortKey}Min`]
                        let maxValue = loadedObject[`${sortKey}Max`]
                        this.$set(condition.value, 0, Number.parseFloat(minValue.substring(minValue.indexOf("=") + 1)))
                        this.$set(condition.value, 1, Number.parseFloat(maxValue.substring(maxValue.indexOf("=") + 1)))
                    }
                }

                for (const item of this.$refs.conditionDialog.items) {
                    if (item.id == sortKey) {
                        item.value = true
                    }
                }
            }

            this.buyConditions.sort((a, b) => {
                if (a.index > b.index) return 1
                if (a.index < b.index) return -1
                return 0
            })

            this.updateBuyConditionsIndex()
        },
        upIndex(item) {
            const oldIndex = this.buyConditions.indexOf(item)
            const index = this.activeConditions.indexOf(item)
            if (index > 0) {
                const changedIndex = this.buyConditions.indexOf(this.activeConditions[index - 1])
                const temp = this.buyConditions[changedIndex]
                this.$set(this.buyConditions, changedIndex, item)
                this.$set(this.buyConditions, oldIndex, temp)

                this.updateBuyConditionsIndex()
            }
        },
        downIndex(item) {
            const oldIndex = this.buyConditions.indexOf(item)
            const index = this.activeConditions.indexOf(item)
            if (index < this.activeConditions.length - 1) {
                const changedIndex = this.buyConditions.indexOf(this.activeConditions[index + 1])
                const temp = this.buyConditions[changedIndex]
                this.$set(this.buyConditions, changedIndex, item)
                this.$set(this.buyConditions, oldIndex, temp)

                this.updateBuyConditionsIndex()
            }
        },
        updateBuyConditionsIndex() {
            let index = 1
            for (let condition of this.buyConditions) {
                for (let item of this.$refs.conditionDialog.items) {
                    if (condition.id == item.id) {
                        condition.active = item.value
                        if (item.value) {
                            condition.index = index
                            index = index + 1
                        }
                    }
                }
            }
        },
        removeBuyCondition(item) {
            this.$refs.conditionDialog.items.find(x => x.id == item.id).value = false
            this.updateBuyConditionsIndex()
        },
        validate() {
            if (this.buyConditions.filter(v => v.message != "").length > 0) {
                this.$toasted.error("백테스트 조건을 다시 확인해주세요")
                return false
            }

            if (this.activeConditions.length < 1) {
                this.$toasted.error("매수 조건을 최소 1개 추가해주세요")
                return false
            }

            return true
        },
    }
}
</script>
